import { Link } from 'react-router';
import { useIntl } from 'react-intl';
import { useFormat } from '@/i18n/useFormat';
import { useLocale } from '@/i18n/useLocale';
import { paths } from '@/app/paths';
import { Odometer, cx } from '@/ui';
import { Emblem } from '@/art/Emblem';
import { useJackpot } from './store';
import s from './jackpot.module.css';

/**
 * Compact «乐游 Jackpot» counter for the header of game screens: the label and the live pool, a link to the check on
 * /fair. Hidden while the jackpot is off or not loaded. `small` — the phone header (number only, label in the title).
 */
export function JackpotChip({ small, className }: { small?: boolean; className?: string }) {
  const jp = useJackpot();
  const f = useFormat();
  const intl = useIntl();
  const l = useLocale();
  if (!jp) return null;
  const label = intl.formatMessage({ id: 'jackpot.short' });
  return (
    <Link
      to={`${paths.fair(l)}#jackpot`}
      className={cx(s.chip, small && s.chipSm, className)}
      title={intl.formatMessage({ id: 'jackpot.title' })}
      aria-label={`${intl.formatMessage({ id: 'jackpot.title' })}: ${f.tokens(jp.pool, { decimals: 0 })}`}
      data-testid="jackpot-chip"
    >
      <Emblem name="jackpot" size={small ? 16 : 18} className={s.chipEmblem} />
      <span className={s.chipLabel} aria-hidden="true">
        {label}
      </span>
      <Odometer value={jp.pool} format={(n) => f.tokens(n, { decimals: 0 })} flash={false} className={s.chipAmount} />
    </Link>
  );
}
